import { useEffect } from 'react'
import { useFormikContext } from 'formik'

import { WidgetItemPipelineBase } from '../../../Widget'

function DocFlowWidgetFormContent({
  activeWidget,
  initialValues,
  name,
  onClickPrevious,
  ...restProps
}) {
  const { values, ...formikHelers } = useFormikContext()

  function handleClickPrevious(index) {
    onClickPrevious({ formikHelers, index, values })
  }

  const isCurrentWidgetActive = activeWidget === name

  useEffect(() => {
    if (isCurrentWidgetActive) {
      formikHelers.resetForm({ values: initialValues })
    }
  }, [initialValues, isCurrentWidgetActive])

  return (
    <WidgetItemPipelineBase
      {...restProps}
      activeWidget={activeWidget}
      initialValues={initialValues}
      name={name}
      onClickPrevious={handleClickPrevious}
    />
  )
}

export default DocFlowWidgetFormContent
